import React from "react";

// IMPORT MATERIAL-UI Components
import { Typography, Backdrop, CircularProgress, Box } from "@material-ui/core";

// import Typography from "@material-ui/core/Typography";
// import Backdrop from "@material-ui/core/Backdrop";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import Box from "@material-ui/core/Box";

import { TableSubmit } from "../submit-datasets/TableSubmit";
import { ActionTableSubmit } from "../submit-datasets/ActionTableSubmit";
import SubmissionDialog from "../submit-datasets/SubmissionDialog";
import ErrorDialog from "../components/ErrorDialog";
import { Submission } from "../Submission";
import auth from "../../../Auth";
import findErrors from "../components/helper";
import {
  project,
  projectSubmissionCols,
  validateProjectSubmission,
} from "../../../apis";

import PopupError from "../components/PopupError";

// neeeded?
// import "./actionTable.css";

const { config } = window;

/**
 * Component for create new datasets.
 * @category Category
 * @subcategory Submission
 * @component
 */

// TODO
// hardcode the Logo Url preset
// ! in the future get it from the config.js

const getSubmissionCols = async () => {
  let jsonData = {};

  const response = await projectSubmissionCols(
    auth.getToken(),
    config.api_endpoint
  );

  if (response.status === 200) {
    jsonData = await response.json();
    return jsonData[0].message;
  }
  return [];
};

const initFormControls = (headersCfg) => {
  const formControls = [];
  headersCfg.forEach((header) => {
    let val = "";

    // preset values
    // TODO in config.js
    // not as list but as mapping

    const boolCols = ["datasetVisibilityChangeable", "fileDlAllowed"];
    if (boolCols.includes(header.id)) {
      val = true;
    }

    if (header.id === "datasetVisibilityDefault") {
      val = "private";
    }

    formControls.push({ id: header.id, index: 0, value: val, error: "" });
  });
  return [formControls];
};

export class SubmitProjects extends Submission {
  constructor(props) {
    super(props);

    // TODO
    // query the headersCfg from the server

    this.state = {
      numberRows: 10,
      headers: [],
      formControls: [],
      redirect: false,
      redirectContents: [[]],
      copyReason: false,
      popupErrors: "",
      csvFileName: "",
      uploading: false,
      rowsSubmitted: 0,
      filledRows: 0,
    };
  }

  async componentDidMount() {
    // initialize a table with 10 rows
    const tableHeaders = await getSubmissionCols();

    this.setState({
      headers: tableHeaders,
      formControls: initFormControls(tableHeaders),
    });
    this.initComponent();
  }

  validate = async () => {
    const formControls = [...this.state.formControls];
    const headers = [...this.state.headers];

    const nonEmptyRowIds = this.getNonEmptyRowIds(formControls, headers);
    const formRows = formControls.filter((_, i) => nonEmptyRowIds.includes(i));

    // TODO
    // integrate below into validateForm
    // early exit if all rows are empty
    if (nonEmptyRowIds.length === 0) {
      this.setState({ formControls, validated: false });
      return;
    }

    this.validateProjectSubmissionForm(formRows);

    // generate data to send POST request
    // to /validate endpoint
    const formData = [];
    for (const row of formRows) {
      const data = {};
      row.forEach((col) => {
        data[col.id] = col.value;
      });
      // data.project_id = this.state.projectId;
      formData.push(data);
    }

    const api_success = [];
    // send POST request
    try {
      const response = await validateProjectSubmission(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify(formData)
      );

      const error_msg = await response.text();
      if (response.status !== 200) {
        api_success.push(false);
        this.setState({ popupErrors: error_msg });
      }
    } catch (err) {
      // TODO
      // add this error handling to all API calls

      this.setState({ popupErrors: "Server is not responding" });
    }

    // this.validateForm(formRows);

    // //get all individual project ids
    // const projects = new Set();
    // formRows.forEach((column) => {
    //   projects.add(column.filter((col) => col.id === "id")[0].value);
    // });

    // if (projects.length !== formRows.length) {
    //   let error_msg = "";
    //   projects.forEach((ds_id) => {
    //     const ids = [];

    //     formRows.forEach((column) => {
    //       if (column.filter((col) => col.id === "id")[0].value === ds_id) {
    //         //check for duplicated dataset ids
    //         if (ids.includes(ds_id)) {
    //           error_msg = "project id already assigned";
    //         } else {
    //           ids.push(ds_id);
    //         }
    //         column.find((col) => col.id === "id").error = error_msg;
    //       }
    //     });
    //   });
    // }

    this.setState({
      formControls,
      validated: true,
    });
    return formRows;
  };

  getValForTable = (id, value) => {
    // if (id === "datasetVisibilityDefault") {
    //   return value ? "private" : "visible to all";
    // }

    if (Array.isArray(value)) {
      return [...new Set(value)].join(" ");
    }

    if (typeof value === "boolean") {
      return value.toString();
    }

    return value;
  };

  createSummaryInserted = (formRows) => {
    const tableContents = [];

    // add table headers
    const tableHeaders = [];
    for (let row of this.state.headers) {
      tableHeaders.push(row.title);
    }
    tableContents.push(tableHeaders);

    // add table values
    for (let row of formRows) {
      const rowValues = [];
      for (let column of row) {
        const { id, value } = column;
        rowValues.push(this.getValForTable(id, value));
      }
      tableContents.push(rowValues);
    }

    //go to Summary Inserted
    const today = new Date().toISOString().slice(0, 10);
    this.setState({
      redirect: true,
      redirectContents: tableContents,
      csvFileName: `${today}_submitted_projects.csv`,
    });
  };

  submit = async () => {
    const formRows = await this.validate();

    // TODO
    // write a test to check if the early exit is working

    // early exit if there are errors in the form or all rows are empty
    if (this.hasErrors(formRows) || this.state.validated === false) {
      return;
    }

    // trigger the loading backdrop and remove form validation notification
    this.setState({
      uploading: true,
      validated: false,
      filledRows: formRows.length,
    });

    const api_success = [];

    // generate data to send POST request
    const formData = [];
    for (let row of formRows) {
      const data = {};
      row.forEach((col) => {
        data[col.id] = col.value;
      });
      formData.push(data);
    }

    // send POST request
    try {
      const response = await project(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify(formData)
      );

      const error_msg = await response.text();
      if (response.status !== 200) {
        api_success.push(false);
        this.setState({ popupErrors: error_msg });
      } else {
        api_success.push(true);
        // update progress
        this.setState({ rowsSubmitted: this.state.rowsSubmitted + 1 });
      }
      if (api_success.every(Boolean)) {
        this.createSummaryInserted(formRows);
      }
    } catch (err) {
      // TODO
      // add this error handling to all API calls
      this.setState({ popupErrors: "Server is not responding" });
    }

    // check if the request was successful
    // let error_msg = await response.text();
    // if (response.status !== 200) {
    //   api_success.push(false);
    //   this.setState({ popupErrors: error_msg });
    // } else {
    //   api_success.push(true);
    //   // update progress
    //   this.setState({ rowsSubmitted: this.state.rowsSubmitted + 1 });
    // }

    // TODO
    // if in api_sucess a false is detected
    // return which rows have failed
    // if (api_success.every(Boolean)) {
    //   this.createSummaryInserted(formRows);
    // }
  };

  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({ popupErrors: "", uploading: false });
  };

  render() {
    const excelTemplate = "project";
    const ERRORS = findErrors(this.state.formControls);

    if (this.state.popupErrors) {
      return (
        <PopupError
          error={this.state.popupErrors}
          onClose={() => this.closeModal()}
        />
      );
    }

    if (this.state.redirect && ERRORS === 0) {
      return (
        <SubmissionDialog
          type={"Projects"}
          onClose={() => this.setState({ redirect: false })}
          tableContents={this.state.redirectContents}
          filename={this.state.csvFileName}
          open={this.state.redirect}
        />
      );
    }

    // render only if logged in as admin
    return (
      <>
        {this.state.validated ? (
          <ErrorDialog
            onClose={() => this.setState({ validated: false })}
            errors={ERRORS}
          />
        ) : null}

        {auth.getUserGroups().includes("admin") ? (
          <>
            <Typography variant={"h5"} align={"center"}>
              {" "}
              Create Project/s{" "}
            </Typography>
            <ActionTableSubmit
              addRow={this.addRow}
              validate={this.validate}
              submit={this.submit}
              reload={this.reload}
              loadFile={this.loadFile}
              getExcel={() => this.getExcel(excelTemplate)}
            />
            <TableSubmit
              headers={this.state.headers}
              contents={this.state.formControls}
              changeHandler={this.changeHandler}
              copyReason={this.state.copyReason}
              changeSelectAutocomplete={this.changeSelectAutocomplete}
            />
            <Backdrop
              style={{ color: "white", zIndex: "100" }}
              open={this.state.uploading}
            >
              <CircularProgress color="inherit" />
              <Box>
                Rows submitted:{this.state.rowsSubmitted}/
                {this.state.filledRows}
              </Box>
            </Backdrop>
          </>
        ) : null}
      </>
    );
  }
}
